module.exports = __webpack_public_path__ + "img/vertical-plate.9ee84f00.jpg";